import React, { useContext } from "react";
const ConstructorContext = React.createContext({
  layout: {
    id: "root",
    items: []
  },
  widgets: {}
});
function useConstructorContext() {
  const context = useContext(ConstructorContext);
  if (context === void 0) {
    throw new Error(`${useConstructorContext.name} hook was used outside of ${ConstructorContext.Provider.name}.`);
  }
  return context;
}
export {
  ConstructorContext,
  useConstructorContext
};
